import React from 'react';
import { Route, IndexRoute } from 'react-router';
import { App, Dashboard, LoginOrRegister, Administrator, Builder, Print,
  PrintPOS, Templates, Autopilot, Delivery, DeveloperTools, Billing, Bookkeeping, Labels, Drafts, DraftEdit } from './pages';
import { getLocale } from './intl/helpers';



/*
 * @param {Redux Store}
 * We require store as an argument here because we wish to get
 * state from the store after it has been authenticated.
 */
export default (store) => {
  const requireAuth = (nextState, replace, callback) => {
    const { user: { authenticated } } = store.getState();

    if (!authenticated) {
      replace({
        pathname: '/login',
        state: { nextPathname: nextState.location.pathname }
      });
    }
    callback();
  };

  const redirectAuth = (nextState, replace, callback) => {
    const { user: { authenticated, detectedLanguage } } = store.getState();
    if (authenticated) {
      const locale = getLocale(detectedLanguage);
      replace({
        pathname: '/' + locale + '/dashboard'
      });
    }
    callback();
  };

  return (
    <Route>
      <Route path="/" component={App}>
        <IndexRoute component={LoginOrRegister} onEnter={redirectAuth}/>
        <Route path="login" component={LoginOrRegister} onEnter={redirectAuth} />
        <Route path="dashboard" component={Dashboard} onEnter={requireAuth} />
        <Route path="builder" component={Builder} onEnter={requireAuth} />
       
       
        <Route path="administrator" component={Administrator} onEnter={requireAuth} />
        <Route path="templates" component={Templates} onEnter={requireAuth} />
        <Route path="autopilot" component={Autopilot} onEnter={requireAuth} />
        <Route path="delivery" component={Delivery} onEnter={requireAuth} />
        <Route path="developer" component={DeveloperTools} onEnter={requireAuth} />
        <Route path="billing" component={Billing} onEnter={requireAuth} />
        
        <Route path="bookkeeping" component={Bookkeeping} onEnter={requireAuth} />
        <Route path="labels" component={Labels} onEnter={requireAuth} />
        <Route path="drafts" component={Drafts} onEnter={requireAuth} />
        <Route path="drafts/edit/:id" component={DraftEdit} onEnter={requireAuth} />
        <Route path="print" component={Print}  />
        <Route path="printPOS" component={PrintPOS}  />
      </Route>
      <Route path="/(:locale)" component={App}>
        <IndexRoute component={LoginOrRegister} onEnter={redirectAuth}/>
        <Route path="login" component={LoginOrRegister} onEnter={redirectAuth} />
        <Route path="dashboard" component={Dashboard} onEnter={requireAuth} />
        <Route path="builder" component={Builder} onEnter={requireAuth} />
        <Route path="administrator" component={Administrator} onEnter={requireAuth} />
        <Route path="templates" component={Templates} onEnter={requireAuth} />
        <Route path="autopilot" component={Autopilot} onEnter={requireAuth} />
        <Route path="developer" component={DeveloperTools} onEnter={requireAuth} />
        <Route path="delivery" component={Delivery} onEnter={requireAuth} />
        <Route path="billing" component={Billing} onEnter={requireAuth} />
        <Route path="bookkeeping" component={Bookkeeping} onEnter={requireAuth} />
        <Route path="labels" component={Labels} onEnter={requireAuth} />
        <Route path="drafts" component={Drafts} onEnter={requireAuth} />
        <Route path="drafts/edit/:id" component={DraftEdit} onEnter={requireAuth} />
        <Route path="print" component={Print}  />
        <Route path="printPOS" component={PrintPOS}  />
      </Route>

    </Route>
  );
};



// WEBPACK FOOTER //
// app/routes.jsx